if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection || this.dataset.section;
            if (event.data.sectionId !== sectionId) return;

            this.updateQuantityRules(sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      setQuantityBoundries() {
        if (!this.input) return;

        const min = Number.parseInt(this.input.dataset.min || this.input.min || '1', 10) || 1;
        const step = Number.parseInt(this.input.step || '1', 10) || 1;
        const cartQuantity = Number.parseInt(this.input.dataset.cartQuantity || '0', 10) || 0;
        const rawTotalMax = this.input.dataset.max;
        const totalMax = rawTotalMax !== undefined && rawTotalMax !== ''
          ? Number.parseInt(rawTotalMax, 10)
          : null;

        const hasMax = Number.isFinite(totalMax);
        const remaining = hasMax ? Math.max(0, totalMax - cartQuantity) : null;
        const cartFull = hasMax && remaining <= 0;

        this.input.min = String(min);
        this.input.step = String(step);

        if (hasMax) {
          this.input.max = String(remaining);
        } else {
          this.input.removeAttribute('max');
        }

        let current = Number.parseInt(this.input.value || '', 10);
        if (!Number.isFinite(current) || current < min) current = min;

        if (cartFull) {
          // Keep a readable value while the purchase controls are disabled.
          this.input.value = String(min);
        } else if (hasMax) {
          this.input.value = String(Math.min(current, remaining));
        } else {
          this.input.value = String(current);
        }

        this.input.dataset.fqCartFull = cartFull ? 'true' : 'false';
        this.syncQuantityButtons(cartFull);
        this.syncPurchaseState(cartFull);

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      syncQuantityButtons(cartFull = false) {
        const wrapper = this.input?.closest('.quantity');
        if (!wrapper) return;

        const minus = wrapper.querySelector('button[name="minus"]');
        const plus = wrapper.querySelector('button[name="plus"]');
        const value = Number.parseInt(this.input.value || '0', 10) || 0;
        const min = Number.parseInt(this.input.min || '1', 10) || 1;
        const max = this.input.hasAttribute('max')
          ? Number.parseInt(this.input.max || '0', 10)
          : null;
        const addSelectionMaxed = !cartFull && Number.isFinite(max) && value >= max;

        wrapper.classList.toggle('fq-selection-maxed', addSelectionMaxed);
        wrapper.classList.toggle('fq-cart-full', cartFull);

        if (minus) {
          minus.disabled = cartFull || value <= min;
          minus.classList.toggle('disabled', minus.disabled);
          minus.setAttribute('aria-disabled', minus.disabled ? 'true' : 'false');
        }

        if (plus) {
          plus.disabled = cartFull || addSelectionMaxed;
          plus.classList.toggle('disabled', plus.disabled);
          plus.setAttribute('aria-disabled', plus.disabled ? 'true' : 'false');
          plus.title = plus.disabled ? 'Quantité maximale disponible atteinte' : '';
        }
      }

      syncPurchaseState(cartFull = false) {
        const buttons = this.querySelector('.product-form__buttons');
        if (!buttons) return;

        buttons.classList.toggle('fq-stock-limit-reached', cartFull);

        const submit = buttons.querySelector('.product-form__submit');
        if (submit) {
          if (cartFull) {
            submit.dataset.fqStockDisabled = 'true';
            submit.disabled = true;
            submit.setAttribute('aria-disabled', 'true');
          } else if (submit.dataset.fqStockDisabled === 'true') {
            delete submit.dataset.fqStockDisabled;
            submit.disabled = false;
            submit.removeAttribute('aria-disabled');
          }
        }

        const dynamic = buttons.querySelector('.shopify-payment-button');
        if (dynamic) dynamic.setAttribute('aria-disabled', cartFull ? 'true' : 'false');

      }

      fetchQuantityRules() {
        this.currentVariant = this.querySelector('.product-variant-id');
        if (!this.currentVariant || !this.currentVariant.value) return;

        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((error) => console.error('Fraquane quantity rules:', error));
      }

      updateQuantityRules(sectionId, html) {
        if (!html || !this.quantityForm) return;

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated) return;

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        for (const selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;

          if (selector === '.quantity__input') {
            const attributes = [
              'data-cart-quantity',
              'data-min',
              'data-max',
              'data-variant-id',
              'min',
              'max',
              'step'
            ];

            for (const attr of attributes) {
              if (updated.hasAttribute(attr)) {
                current.setAttribute(attr, updated.getAttribute(attr));
              } else {
                current.removeAttribute(attr);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }

        this.input = this.quantityForm.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
      }
    }
  );
}